import React, { useEffect, useState } from 'react'
import { InputText } from 'primereact/inputtext'
import PhoneInput from 'react-phone-number-input'
import { Button } from 'primereact/button'
import './FormComponent.scss'
import Timer from '../Timer/Timer'
import ThankYouLetter from '../ThankYouLetter/ThankYouLetter'
import { apply, geo } from '../../service/api'
import { formatedPath, getUtms } from '../../service/url'
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox'
// import { useNavigate } from 'react-router-dom'

let isGeo = false
const geoData = {}

if (!isGeo) {
	isGeo = true
	geo()
		.then(({ data }) => {
			geoData['city'] = data.city
			geoData['country'] = data.country_name
			geoData['timezone'] = data.time_zone.name
		})
		.catch((error) => console.log(error))
}

const Form = ({ selectedTariff, data, setIsFormSubmitted, isFormSubmitted }) => {
	// const navigate = useNavigate()
	const [name, setName] = useState('')
	const [nameError, setNameError] = useState('Пожалуйста, введите ваше имя')
	const [nameDirty, setNameDirty] = useState(false)

	const [price, setPrice] = useState('')
	const [priceError, setPriceError] = useState('Пожалуйста, введите сумму')
	const [priceDirty, setPriceDirty] = useState(false)

	const [email, setEmail] = useState('')
	const [emailDirty, setEmailDirty] = useState(false)
	const [emailError, setEmailError] = useState('Пожалуйста, введите ваш E-mail')

	const [phone, setPhone] = useState('')
	const [phoneDirty, setPhoneDirty] = useState(false)
	const [phoneError, setPhoneError] = useState('Пожалуйста, введите ваш номер телефона')

	const [isSubmit, setIsSubmit] = useState(false)
	const [isButtonLoading, setIsButtonLoading] = useState(false)
	const [paymentData, setPaymentData] = useState(null)

	const [product, setProduct] = useState('product')
	const [id, setId] = useState(null)

	const [checked, setChecked] = useState(false);

	useEffect(() => {
		setId(product === 'prepay-product' ? selectedTariff?.prepay_product_id : selectedTariff?.apply_config_id)
	}, [selectedTariff, product])

	const formatNumber = (number) => {
		return Intl.NumberFormat('ru-RU').format(number)
	}

	const showInfo = () => {
		if ((!selectedTariff?.current_price && !selectedTariff?.discount_product?.length > 0) || selectedTariff?.is_hand_price ) {
			return true
		} else {
			return false
		}
	}

	const discountProduct = () => {
		let formated = selectedTariff?.discount_product.map((product, index) => {
			return <div key={index}>+ {product}</div>
		})
		return formated
	}

	const validateName = (name) => {
		setName(name)
		if (name.length < 2) {
			setNameError('Имя должно быть длиннее 2-х символов')
			if (!name) {
				setNameError('Пожалуйста, введите ваше имя')
			}
		} else {
			setNameError('')
		}
	}

	const validatePrice = (price) => {
		setPrice(price)
		if (isNaN(price) || Number(price) <= 0) {
			setPriceError('Сумма должна быть числом больше 0')
			if (!price) {
				setPriceError('Пожалуйста, введите сумму')
			}
		} else {
			setPriceError('')
		}
	}

	const validateEmail = (email) => {
		setEmail(email)
		const isValid = String(email)
			.toLowerCase()
			.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
		isValid ? setEmailError('') : setEmailError('Некорректный Email')
	}

	const validatePhone = (phone) => {
		setPhone(phone)
		if (phone?.length < 10 || !phone) {
			setPhoneError('Введен некорректный номер телефона')
			if (!phone) {
				setPhoneError('Пожалуйста, введите ваш номер телефона')
			}
		} else {
			setPhoneError('')
		}
	}

	const blurHandler = (e) => {
		switch (e.target.name) {
			case 'name':
				setNameDirty(true)
				break
			case 'email':
				setEmailDirty(true)
				break
			case 'phone':
				setPhoneDirty(true)
				break
			case 'price':
				setPriceDirty(true)
				break
			default:
    			console.log(`Sorry, we are out of ${e.target.name}.`);
		}
	}

	// Отправка формы
	const submitForm = () => {
		if (nameError || emailError || phoneError || (selectedTariff?.is_hand_price && priceError)) {
			setNameDirty(true)
			setEmailDirty(true)
			setPhoneDirty(true)
			setPriceDirty(true)
		} else {
			setIsButtonLoading(true)
			const userData = { email, name, phone, price, apply_config_id: id, ...getUtms(), ...geoData, site: formatedPath(true) }
			// console.log(userData)
			apply(userData)
				.then((payments) => {
					setIsFormSubmitted(true)
					setIsButtonLoading(false)
					setIsSubmit(true)
					setPaymentData(payments.data)
					window.scroll(0, 0)
				})
				.catch((err) => {
					setIsButtonLoading(false)
					console.log(err)
				})

		}

	}

	return (
		<>
			{isSubmit && <ThankYouLetter data={data} paymentData={paymentData} />}
			{!isSubmit && (
				<div className="pl-0 lg:pl-4">
					{!showInfo() && (
						<div className="info">
							<div className="price-block">
								{selectedTariff?.current_price && (
									<>
										<div>
											<Timer data={data} timerEnd={data?.timer_date} />
										</div>
										{product !== 'prepay-product' && <div className="price">{formatNumber(selectedTariff?.current_price) + ' ₽'}</div>}
										{product === 'prepay-product' && <div className="price">{formatNumber(selectedTariff?.prepay_price) + ' ₽'}</div>}

									</>
								)}
							</div>

							<div className="oldPrice">{selectedTariff?.old_price && selectedTariff?.current_price && formatNumber(selectedTariff?.old_price) + ' ₽'}</div>
							{selectedTariff?.discount_product && selectedTariff?.discount_product?.length != 0 && <div className="discountProduct"> {discountProduct()}</div>}
						</div>
					)}

					{selectedTariff?.prepay_product_id &&
						<div className='flex radiobuttons'>
							<div className="field-radiobutton mr-5">
								<RadioButton inputId="product" name="product" value="product" onChange={(e) => setProduct(e.value)} checked={product === 'product'} />
								<label htmlFor="product">{selectedTariff?.full_title ? selectedTariff?.full_title : data?.title_full_price}</label>
							</div>
							<div className="field-radiobutton">
								<RadioButton inputId="prepay-product" name="product" value="prepay-product" onChange={(e) => setProduct(e.value)} checked={product === 'prepay-product'} />
								<label htmlFor="prepay-product">{selectedTariff?.second_title ? selectedTariff?.second_title : data?.title_installment_price}</label>
							</div>
						</div>
					}

					<div className="booking-form">
						{/* {!showInfo() && <h3 className="booking-form-title hidden lg:block">Начать учиться</h3>} */}
						
						{selectedTariff?.is_hand_price && 
							<div className="field mb-3">
								<InputText required name="price" type="text" value={price} onChange={(e) => validatePrice(e.target.value)} onBlur={(e) => blurHandler(e)} className="w-full " placeholder="Сумма*" />
								{priceDirty && priceError && <small className="p-error block">{priceError}</small>}
							</div>
						}
						
						<div className="field mb-3">
							<InputText required name="name" type="text" value={name} onChange={(e) => validateName(e.target.value)} onBlur={(e) => blurHandler(e)} className="w-full " placeholder="Ваше имя*" />
							{nameDirty && nameError && <small className="p-error block">{nameError}</small>}
						</div>
						<div className="field mb-3">
							<InputText required name="email" type="email" value={email} onChange={(e) => validateEmail(e.target.value)} onBlur={(e) => blurHandler(e)} className="w-full" placeholder="E-mail*" />
							{emailDirty && emailError && <small className="p-error block">{emailError}</small>}
						</div>
						<div className="field mb-4">
							<PhoneInput className="phone w-full" required name="phone" placeholder="Телефон*" value={phone} onChange={(e) => validatePhone(e)} onBlur={(e) => blurHandler(e)} />
							{phoneDirty && phoneError && <small className="p-error block">{phoneError}</small>}
						</div>
						<div>
							{!isFormSubmitted && (
								<div className="col-12 lg:col-4 w-full p-0">
									<div className="">
										{data && (
											<>
												{(!['OOO', 'OOO_CONF', 'AE', 'OOO_DOP', 'OOO_UPC', 'OOO_1'].includes(data.company)) &&
													<div className="field-checkbox">
														<Checkbox className='accept' inputId="binary" checked={checked} onChange={e => setChecked(e.checked)} />
														<label htmlFor="binary">
															<p className="terms">
																Я принимаю условия <a href="https://tl.ashahov.ru/public_offer">публичной оферты</a>, <a href="/assets/docs/conf.pdf">политики конфиденциальности</a>, <a href="/assets/docs/extention_conditions.pdf">возврата</a>, и даю <a href="/assets/docs/adv.pdf">cогласие на получение рекламы</a>.
															</p>
														</label>
													</div>

												}
												{data.company === 'OOO' &&
													<div className="field-checkbox">
														<Checkbox className='accept' inputId="binary" checked={checked} onChange={e => setChecked(e.checked)} />
														<label htmlFor="binary">
															<p className="terms">
																Я принимаю условия <a href="https://ippshahov.com/public/offer">публичной оферты</a>, <a href="https://ippshahov.com/public/privacy">политики обработки персональных данных</a>, <a href="https://ippshahov.com/public/pravila_vozvrata">возврата</a>, и даю <a href="https://ippshahov.com/public/ad-agreement">cогласие на получение рекламы</a>.
															</p>
														</label>
													</div>

												}
												{data.company === 'OOO_CONF' &&
													<div className="field-checkbox">
														<Checkbox className='accept' inputId="binary" checked={checked} onChange={e => setChecked(e.checked)} />
														<label htmlFor="binary">
															<p className="terms">
																Я принимаю условия <a href="/assets/docs/offer_conf.pdf">публичной оферты</a>, <a href="https://ippshahov.com/public/privacy">политики обработки персональных данных</a>, <a href="https://ippshahov.com/public/pravila_vozvrata">возврата</a>, и даю <a href="https://ippshahov.com/public/ad-agreement">cогласие на получение рекламы</a>.
															</p>
														</label>
													</div>

												}
												{data.company === 'AE' &&
													<div className="field-checkbox">
														<Checkbox className='accept' inputId="binary" checked={checked} onChange={e => setChecked(e.checked)} />
														<label htmlFor="binary">
															<p className="terms">
																Я принимаю условия <a href="https://ashahov.com/oferta_ae">публичной оферты</a>, <a href="/assets/docs/conf.pdf">политики конфиденциальности</a>, <a href="/assets/docs/extention_conditions.pdf">возврата</a>, и даю <a href="/assets/docs/adv.pdf">cогласие на получение рекламы</a>.
															</p>
														</label>
													</div>

												}
												{data.company === 'OOO_DOP' &&
													<div className="field-checkbox">
														<Checkbox className='accept' inputId="binary" checked={checked} onChange={e => setChecked(e.checked)} />
														<label htmlFor="binary">
															<p className="terms">
																Я принимаю условия <a href="/assets/docs/offer_ooo_dop.pdf">публичной оферты</a>, <a href="https://ippshahov.com/public/privacy">политики обработки персональных данных</a> и даю <a href="https://ippshahov.com/public/ad-agreement">cогласие на получение рекламы</a>.
															</p>
														</label>
													</div>
												}
												{data.company === 'OOO_UPC' &&
													<div className="field-checkbox">
														<Checkbox className='accept' inputId="binary" checked={checked} onChange={e => setChecked(e.checked)} />
														<label htmlFor="binary">
															<p className="terms">
																Я принимаю условия <a href="https://ippshahov.com/public/offer_upc">публичной оферты</a>, <a href="https://ippshahov.com/public/privacy">политики обработки персональных данных</a> и даю <a href="https://ippshahov.com/public/ad-agreement">cогласие на получение рекламы</a>.
															</p>
														</label>
													</div>
												}
												{data.company === 'OOO_1' &&
													<div className="field-checkbox">
														<Checkbox className='accept' inputId="binary" checked={checked} onChange={e => setChecked(e.checked)} />
														<label htmlFor="binary">
															<p className="terms">
															Я принимаю условия <a href="https://ippshahov.com/public/offer1">публичной оферты</a>, <a href="https://ippshahov.com/public/privacy">политики обработки персональных данных</a>, <a href="https://ippshahov.com/public/pravila_vozvrata">возврата</a>, и даю <a href="https://ippshahov.com/public/ad-agreement">cогласие на получение рекламы</a>.
															</p>
														</label>
													</div>
												}
											</>

										)}
									</div>
								</div>
							)}
						</div>

						<Button disabled={!checked} label={selectedTariff?.submit_button_title || data?.submit_button_title || 'Отправить'} onClick={() => submitForm()} loading={isButtonLoading} iconPos="left" />
					</div>
				</div>
			)}
		</>
	)
}

export default Form
